import {
  APP_NS,
  API_CACHE_PREFIX,
  LEGACY_SESSION_KEYS,
  LEGACY_STORAGE_KEYS,
  STORAGE_KEYS,
} from '@/constants/appIdentity'

const LEGACY_TO_STORAGE = {
  'user-token': STORAGE_KEYS.token,
  'user-info': STORAGE_KEYS.userInfo,
  vuex: STORAGE_KEYS.vuex,
  'web-config': STORAGE_KEYS.webConfig,
  'web-config:v2': STORAGE_KEYS.webConfigV2,
  support_user_access_token: STORAGE_KEYS.supportToken,
}

const LEGACY_TO_SESSION = {
  gate_cb: STORAGE_KEYS.gateCb,
}

const LEGACY_API_CACHE_PREFIX = 'ysm:api-cache:'

function migrateKeyMap(storage, map) {
  if (!storage) return
  Object.keys(map).forEach((legacyKey) => {
    const nextKey = map[legacyKey]
    try {
      const legacyValue = storage.getItem(legacyKey)
      if (legacyValue == null) return
      if (storage.getItem(nextKey) == null) {
        storage.setItem(nextKey, legacyValue)
      }
      storage.removeItem(legacyKey)
    } catch (e) {
      // ignore
    }
  })
}

function removeLegacyKeys(storage, keys) {
  if (!storage) return
  keys.forEach((key) => {
    try {
      storage.removeItem(key)
    } catch (e) {
      // ignore
    }
  })
}

function clearLegacyApiCache(storage) {
  if (!storage) return
  try {
    const keysToRemove = []
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i)
      if (key && key.startsWith(LEGACY_API_CACHE_PREFIX)) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach((key) => storage.removeItem(key))
  } catch (e) {
    // ignore
  }
}

/** 仅清除本项目命名空间下的 local/session 键 */
export function clearAppStorage() {
  const prefix = `${APP_NS}:`
  ;[localStorage, sessionStorage].forEach((storage) => {
    try {
      const keysToRemove = []
      for (let i = 0; i < storage.length; i += 1) {
        const key = storage.key(i)
        if (key && (key.startsWith(prefix) || key.startsWith(API_CACHE_PREFIX))) {
          keysToRemove.push(key)
        }
      }
      keysToRemove.forEach((key) => storage.removeItem(key))
    } catch (e) {
      // ignore
    }
  })
}

export function migrateLegacyStorage() {
  try {
    migrateKeyMap(localStorage, LEGACY_TO_STORAGE)
    removeLegacyKeys(localStorage, LEGACY_STORAGE_KEYS)

    migrateKeyMap(sessionStorage, LEGACY_TO_SESSION)
    removeLegacyKeys(sessionStorage, LEGACY_SESSION_KEYS)
    clearLegacyApiCache(sessionStorage)
  } catch (e) {
    // ignore
  }
}

migrateLegacyStorage()
